/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentAcceptance } from './DocumentAcceptance';
import {
    DocumentAcceptanceFromJSON,
    DocumentAcceptanceFromJSONTyped,
    DocumentAcceptanceToJSON,
    DocumentAcceptanceToJSONTyped,
} from './DocumentAcceptance';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface ListDocumentAcceptancesResponse
 */
export interface ListDocumentAcceptancesResponse {
    /**
     * 
     * @type {Array<DocumentAcceptance>}
     * @memberof ListDocumentAcceptancesResponse
     */
    data: Array<DocumentAcceptance>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListDocumentAcceptancesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListDocumentAcceptancesResponse interface.
 */
export function instanceOfListDocumentAcceptancesResponse(value: object): value is ListDocumentAcceptancesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListDocumentAcceptancesResponseFromJSON(json: any): ListDocumentAcceptancesResponse {
    return ListDocumentAcceptancesResponseFromJSONTyped(json, false);
}

export function ListDocumentAcceptancesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDocumentAcceptancesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(DocumentAcceptanceFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListDocumentAcceptancesResponseToJSON(json: any): ListDocumentAcceptancesResponse {
      return ListDocumentAcceptancesResponseToJSONTyped(json, false);
  }

  export function ListDocumentAcceptancesResponseToJSONTyped(value?: ListDocumentAcceptancesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(DocumentAcceptanceToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

